import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-combined-shape",
  "use": "icon-combined-shape-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"icon-combined-shape\"><path d=\"M15.759 3.076H5.896V.92H2.61v7.472h3.285V6.234h9.863v2.157h3.285V.92H15.76v2.157Zm-3.285 10.87h3.285v3.157H5.896v-3.158H9.18v-5.16h3.285v5.16h.008ZM.922 20.785V12.79l3.285 1.163v6.832H.922Zm16.518 0v-6.833l3.285-1.163v7.995H17.44Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol